export const typeKeys = {
  input: 'input',
  textarea: 'textarea',
};
